import { handlers, config } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.alertAPI;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/alertEmails/account/${accountID}`
      }, API))
  );
}

async function getByMachineId(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/alertEmails/${machineID}`
      }, API))
  );
}

async function getById(recipientID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/recipients/${recipientID}`
      }, API))
  );
}

async function create(recipient) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/alertEmails',
        body: JSON.stringify(recipient)
      }, API))
  );
}

async function update(recipients, accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/alertEmails/${accountID}`,
        body: JSON.stringify(recipients)
      }, API))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(recipients) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: '/alertEmails',
        body: JSON.stringify(recipients)
      }, API))
  );
}

const recipientService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete,
  getByMachineId,
};

export default recipientService;
